

















































import Vue, { PropType } from 'vue';
import { urlFor } from '@/config/sanity';
import Customer from '@/models/customer';
import Quote from '@/models/quote';

export default Vue.extend({
  name: 'CustomersPanel',
  props: {
    customers: {
      type: Array as PropType<Array<Customer>>,
      required: true,
    },
    quotes: {
      type: Array as PropType<Array<Quote>>,
      required: false,
    },
    headline: {
      type: String,
      default: () => 'Kunder',
    },
    headlineSize: String,
    headlinePosition: String,
  },
  methods: {
    urlFor,
  },
});
